import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";
import Pagination from "../admin/common/Pagination";
import NoData from "../admin/common/NoData";
import ReactAudioPlayer from "react-audio-player";
import Drag from "./dragNdDrop";
import { event } from "jquery";

const MultipleAudioModel = ({ isShown, hide, close, packageDetails }) => {
  //Set initial state
  const [audioList, handleAudioList] = useState([]);
  const [selectedAudios, setSelectedAudios] = useState([]);
  const [noDataClass, handleNoDataClass] = useState("none");
  const [dataClass, handleDataClass] = useState("none");
  const [count, handleCount] = useState(0);
  const [skip, handleSkip] = useState(0);
  const [addedAudio, handleAddedAudio] = useState([]);
  const [isPopupValid, handleIsPopupValid] = useState(false);
  const [totalSecondages, handleTotalSecondages] = useState(0);
  const [packageData, handlePackageData] = useState(packageDetails);

  
  /* const getPageItems = async (skip) => {
    await getAudioManagementList(skip);
  }; */

  const closePopup = () => {
    hide();
  };
  
  useEffect( ()=>{
    calculateUploadedMultipleAudio();
  }, [addedAudio])

  useEffect(() => {
    getAudioManagementList(0);
  }, []);

  // Show file size in bytes
  const bytesToSize = (bytes, decimals = 2) => {
    var sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes == 0) return "0 bytes";
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed()) + " " + sizes[i];
  };
  

  const getNumberOfDays = (indexOfAddedAudio, e) => {
    let allAudioData = addedAudio;
    allAudioData[indexOfAddedAudio]['numberOfDays'] = e.target.value;
    handleAddedAudio([...allAudioData]);
  }

  const getRotationsPerDay = (indexOfAddedAudio, e) => {
    let allAudioData = addedAudio;
    allAudioData[indexOfAddedAudio]['rotationsPerDay'] = e.target.value;
    handleAddedAudio([...allAudioData]);
  }

  const getUploadedAudioFile = (indexOfAddedAudio, e, files) => {
    let fileIndex = indexOfAddedAudio;
    let file = files[0];
    let reader = new FileReader();

    let allAudioData = addedAudio;

    allAudioData[fileIndex]['audio'] = file.name;
    allAudioData[fileIndex]['blob'] = file;
    handleAddedAudio([...allAudioData]);

    reader.onload = function() {
      let audio = new Audio(reader.result);
      audio.onloadedmetadata = () => {
        let audio_duration = parseInt(Math.floor(audio.duration));
        let allAudioData = addedAudio;

        allAudioData[fileIndex]['src'] = audio.src;
        allAudioData[fileIndex]['audioLength'] = audio_duration;
        handleAddedAudio([...allAudioData]);
      };
    };
    reader.readAsDataURL(file);
  }

  const selectExistingAudio = (fileIndex, e) => {
    let selectedAudioListIndex = e.target.value;
    let audioData = audioList[selectedAudioListIndex];
    let allAudioData = addedAudio;

    allAudioData[fileIndex]['audio'] = audioData.fileName;
    allAudioData[fileIndex]['src'] = audioData.audioUrl;
    allAudioData[fileIndex]['relativeSource'] = audioData.audioUrlPath;
    handleAddedAudio([...allAudioData]);
    
    let audio = new Audio(audioData.audioUrl);
    audio.onloadedmetadata = () => {
      let audio_duration = parseInt(Math.floor(audio.duration));
      let allAudioData = addedAudio;
      allAudioData[fileIndex]['audioLength'] = audio_duration;
      handleAddedAudio([...allAudioData]);
    };

    console.log(allAudioData);
  }

  const addRows = (e) => {
    // console.log(audioList);
    e.preventDefault();
    let rowData = { audio: undefined, src: undefined, audioLength: undefined, numberOfDays: undefined, rotationsPerDay: undefined, totalSeconds: undefined};

    handleAddedAudio([...addedAudio, rowData]);
  }

  const removeRow = (indexOfAddedAudio, e) => {
    let addedRowsCopy = addedAudio;

    addedRowsCopy = addedRowsCopy.filter( (row, rowIndex) => {
      return rowIndex != indexOfAddedAudio;
    });
    
    handleAddedAudio([...addedRowsCopy]);
  }

  const calculateUploadedMultipleAudio = () => {
    let allAddedAudios = addedAudio;
    let totalSeconds = 0;
    let isValid = true;
    
    for (const audioData of allAddedAudios) {
      if(audioData.audio && audioData.audioLength && audioData.numberOfDays && audioData.rotationsPerDay){
        audioData.totalSeconds = audioData.audioLength * ( audioData.numberOfDays * audioData.rotationsPerDay );
        totalSeconds += audioData.totalSeconds;
      }else{
        isValid = false;
      }
    }

    // verify if package seconds and uploaded data matches
    if(isValid){
      if( packageData.stations && packageData.stations.length && (packageData.secondages/packageData.stations.length) == totalSeconds){
        handleIsPopupValid(true);
      }
      else if( packageData.secondages == totalSeconds ){
        handleIsPopupValid(true);
      }
      else{
        handleIsPopupValid(false);
      }
    }else{
      handleIsPopupValid(false);
    }

    handleAddedAudio([...allAddedAudios]);
    handleTotalSecondages(totalSeconds);
  }

  const submitMultipleAudios = (e) => {
    e.preventDefault();
    // update localstorage to get uploaded data in campaign
    // localStorage.setItem("MultipleAudioData", JSON.stringify(addedAudio));
    hide(addedAudio);
    handleAddedAudio([]);
  }

  const getAudioManagementList = async (skip, name) => {
    try {
      handleSkip(skip);
      const data = await Axios.get(endPoints.getPreviousAudioByUser, {
        params: {
          skip,
          userEmail: JSON.parse(localStorage.getItem("userInfo")).email,
          name,
        },
      });
      const result = data.data.data.data;
      
      if (result && result.length > 0) {
        handleAudioList(result);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* (()=>{
    if(isShown && addedAudio.length == 0){
      if(multiDurationAudioDetail && multiDurationAudioDetail.length){
        handleAddedAudio(multiDurationAudioDetail);
      }
    }
  }); */

  return isShown ? (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper existing-audio-popup"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <form className="form-group">
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={(e)=>{
                    handleAddedAudio([]);
                    close();
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <div className="running_cap_head">
                    <h2 className="camp_head">Upload Multi-Duration Audio</h2>
                    <div className="camp_right">
                      <div className="search_name" style={{marginRight: "50px"}}>
                        
                        <button style={{padding: "10px 20px", backgroundColor: "#065BAA", color: "#fff", border: "none", borderRadius: "4px", outline: "none", marginLeft: "5px"}} onClick={addRows}> + Add Audio</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" modal-body">
                  <div className="bg-white">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs nonFct">
                        <div className="dashboard-content userListing-dashboard bg-white table-responsive">
                          <table
                            className={
                              addedAudio.length > 0
                                ? "table master-table contact_list"
                                : "table master-table contact_list none"
                            }
                          >
                            <thead>
                              <tr>
                                <th>Select File</th>
                                <th>Audio</th>
                                <th>Audio Size</th>
                                <th>Number of Days</th>
                                <th>Rotations per Day</th>
                                <th>Secondages</th>
                                <th>Remove</th>
                              </tr>
                            </thead>
                            <tbody>
                              { addedAudio && addedAudio.map((audio, i) => (
                                <tr key={i}>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                    { audio.audio ? (<span>{audio.audio}</span>) : (
                                      <div style={{display: "inline-flex", alignItems: "center"}}>
                                        <label style={{
                                          fontSize: "14px", border: "1px solid", padding: "2px 5px", color: "white", background: "#065baa"
                                        }}>
                                          <input accept="audio/mp3,audio/mpeg,audio/wav" type="file" name="multiplefiles[]" onChange={(e)=>{
                                            getUploadedAudioFile(i, e, e.target.files);
                                          }} style={{display: "none"}} /> 
                                          Upload Audio
                                        </label>
                                        &nbsp;or&nbsp;
                                        <select style={{padding: "10px"}} onChange={ (e) => { selectExistingAudio(i,e); }}>
                                          <option value="">Select Existing Audio</option>
                                          { audioList && audioList.length && audioList.map((exAudio, exIndex)=> (
                                            <option value={exIndex}>{exAudio.fileName}</option>
                                          ))}
                                        </select>
                                      </div>
                                    ) }
                                    
                                  </td>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                    { audio.src ?
                                    <ReactAudioPlayer
                                      src={audio.src}
                                      controls
                                      controlsList="nodownload"
                                      onLoadedMetadata={(a) => {
                                        audio.audioDuration = Math.floor(
                                          a.target.duration
                                        );
                                      }}
                                    /> :
                                      '--' 
                                    }

                                  </td>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                  { audio.audioLength ? (<span>{audio.audioLength}</span>) : "--"}
                                  </td>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                    <input
                                      type="number"
                                      placeholder="Number of days"
                                      min="1"
                                      step="1"
                                      max={packageData.days}
                                      style={{padding: "10px", width: "100%"}}
                                      onChange={(e)=>{
                                        getNumberOfDays(i, e);
                                      }}
                                    />
                                  </td>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                    <input
                                      type="number"
                                      placeholder="Rotations per Day"
                                      min="1"
                                      max={packageData.rotationPerDay}
                                      step="1"
                                      style={{padding: "10px", width: "100%"}}
                                      onChange={(e)=>{
                                        getRotationsPerDay(i, e)
                                      }}
                                    />
                                  </td>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                    { audio.totalSeconds ? audio.totalSeconds : "--" }
                                  </td>
                                  <td style={{textAlign: "center", verticalAlign: "middle"}}>
                                    <span style={{cursor: "pointer",  textDecoration: "underline", fontSize: ".85em", color: "#ca6969" }} onClick={(e)=>{ removeRow(i, e) }}>Remove</span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            
                            
                          </table>

                          <div style={{width: "100%"}}>
                            <div style={{width: "30%", float: "right"}}>
                              Package Secondages: <b style={{float: "right"}}>{packageData.stations.length ? (packageData.secondages/packageData.stations.length) : packageData.secondages}</b>{" "}
                              <br/>
                              Total Seconds: <b style={{float: "right"}}>{totalSecondages}</b>{" "}
                              <br/>
                              Remaining Seconds: <b style={{float: "right"}}>{(packageData.stations.length ? packageData.secondages/packageData.stations.length : packageData.secondages) - totalSecondages}</b>{" "}
                            </div>
                          </div>
                          <br/>
                          <br/>
                          <br/>
                          <div className="create_camp_btn" style={{width: "100%", marginTop: "50px"}}>
                            { isPopupValid ? (
                              <button style={{float: "right"}} onClick={(e)=>{submitMultipleAudios(e)}}>Submit</button>
                            ) : 
                              (
                                addedAudio.length > 0 ? (<button style={{cursor: "not-allowed", pointerEvents: "none", opacity: "0.75", background: "#d4d4d4", float: "right"}}>Submit</button>): ''
                              )
                            }
                            
                          </div>
                          
                          {/* <div className="paginationTable">
                            {(skip > 0 || count >= 10) && (
                              <Pagination
                                getAllData={getPageItems}
                                limit={10}
                                totalRecords={count}
                              />
                            )}
                          </div> */}
                        </div>
                        {addedAudio.length === 0 ? <h4>Click on "Add Audio" to add multiple audio's.</h4> : null}
                      </div>
                      {/*<div className="create-camp nonfct-submit">
                  <button onClick={handleContactsUsRemarks}>SAVE CHANGES</button>
                </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default MultipleAudioModel;



// WEBPACK FOOTER //
// ./web/components/campaign/multipleAudioModel.js